import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { Link } from "eddev/routing"
import { ResponsiveImage } from "./ResponsiveImage"
import { themes } from "./Themed"
import { ResponsiveImageFragment } from "../../types.graphql"

export const InsightTile = ({
  id,
  uri,
  theme = "slateLight",
  image,
  title,
  type,
  typeUri,
  date,
  active,
  delay,
  small = false,
  className,
}: {
  id: string
  uri: string
  theme?: string
  image?: ResponsiveImageFragment | null
  title: string
  type?: string
  typeUri?: string
  date?: string
  active?: boolean
  delay?: number
  small?: boolean
  className?: string
}) => {
  const themeObj = !!image ? themes["slateDark"] : themes[theme as keyof typeof themes]

  return (
    <Appear active={active} activeOnly delay={delay}>
      <Link
        href={uri}
        className={cn(
          "w-full rounded-md  flex flex-col justify-between p-5 md:p-4 relative overflow-hidden",
          themeObj.bg,
          themeObj.text,
          !small && "aspect-[352/240] md:aspect-[520/240]",
          small && "aspect-[352/210] md:aspect-[520/132]",
          className,
        )}
      >
        {image && (
          <Appear delay={delay} zoom duration={1000} className="w-full h-full absolute left-0 top-0">
            <ResponsiveImage {...image} className="w-full h-full absolute left-0 top-0" objectFit="cover" />
            <div className="w-full h-full absolute left-0 top-0 bg-slate950/35" />
          </Appear>
        )}
        <Appear
          className={cn("relative text-pretty", !small && "type-serif-xl-regular", small && "type-serif-lg-regular")}
          delay={150}
          active={active}
          activeOnly
        >
          {title}
        </Appear>
        <div className="flex gap-1 items-center relative type-mono-xs-regular uppercase">
          {type && <p>{type}</p>}
          <span>/</span>
          {date && <p>{date}</p>}
        </div>
      </Link>
    </Appear>
  )
}
